import SockJS from "sockjs-client";
import Stomp from "webstomp-client";
import store from "@/store";
import Configuration from "@/configuration";
import initSubscriptions from "./subscriptions";

let stompClient = null;
let reconnectTimeout = null;
let isConnecting = false;
const RECONNECT_DELAY = 5000;

const isWSConnected = () => {
  return !!(
    stompClient &&
    stompClient.connected &&
    stompClient.ws &&
    stompClient.ws.readyState === WebSocket.OPEN
  );
};

const destroyConnection = () => {
  try {
    if (!stompClient) {
      return;
    }

    if (stompClient.ws) {
      try {
        stompClient.ws.close();
      } catch (e) {
        console.error(e);
      }
    }

    stompClient.connected = false;

    stompClient = null;
  } catch (e) {
    console.error(e);
  }
};

const reconnectWS = () => {
  if (reconnectTimeout) {
    return;
  }

  console.warn(`WS reconnect scheduled in ${RECONNECT_DELAY / 1000}s`);

  reconnectTimeout = setTimeout(() => {
    reconnectTimeout = null;

    connectWS();
  }, RECONNECT_DELAY);
};

const connectWS = async () => {
  if (isConnecting || isWSConnected()) {
    return;
  }

  destroyConnection();

  isConnecting = true;

  try {
    const token = store.getters["auth/accessToken"];

    if (!token) {
      isConnecting = false;
      return;
    }

    const url = `${Configuration.value(
      "apiEndpoint",
    )}/api/profile/ws?access_token=${token}`;
    const socket = new SockJS(url);
    stompClient = Stomp.over(socket);
    stompClient.debug = () => {};
    stompClient.connect(
      {
        heartbeat: {
          outgoing: 20000,
          incoming: 20000,
        },
      },

      async () => {
        isConnecting = false;

        if (reconnectTimeout) {
          clearTimeout(reconnectTimeout);
          reconnectTimeout = null;
        }

        try {
          const profileId = store.getters["profile/profileId"];
          if (profileId) {
            await store.dispatch("filterTabs/getFilterTabs", profileId);
          }
        } catch (e) {
          console.error(e);
        }

        initSubscriptions(stompClient);
      },

      (error) => {
        console.error(error);

        isConnecting = false;

        if (stompClient) {
          stompClient.connected = false;
        }

        reconnectWS();
      },
    );

    socket.onclose = () => {
      isConnecting = false;

      if (stompClient) {
        stompClient.connected = false;
      }

      reconnectWS();
    };
  } catch (e) {
    console.error(e);

    isConnecting = false;

    if (stompClient) {
      stompClient.connected = false;
    }

    reconnectWS();
  }
};

const disconnectWS = () => {
  if (reconnectTimeout) {
    clearTimeout(reconnectTimeout);
    reconnectTimeout = null;
  }

  if (stompClient) {
    stompClient.disconnect(() => {
      stompClient.connected = false;
      stompClient = null;
    });
  }
};

document.addEventListener("visibilitychange", () => {
  if (document.visibilityState === "visible" && !isWSConnected()) connectWS();
});

window.addEventListener("beforeunload", () => {
  disconnectWS();
});

export { connectWS, disconnectWS };
